{
  "eyebrow": "Sukurkite paskyrą",
  "title": "Šiek tiek informacijos apie jūsų įmonę.",
  "sub": "Būsite pagrindinis administratorius. Po sąrankos galėsite pakviesti daugiau administratorių.",
  "company": "Įmonė",
  "companyName": "Įmonės pavadinimas",
  "companyVat": "PVM mokėtojo kodas",
  "companyVatBssHint": "Reikalinga Belgijos socialinio draudimo deklaracijoms (DIMONA).",
  "companyCountry": "Šalis",
  "companySector": "Veiklos sritis",
  "companySectorPlaceholder": "Pasirinkite veiklos sritį",
  "sectors": {
    "construction": "Statybos paslaugos",
    "cleaning": "Valymo paslaugos",
    "business": "Verslo paslaugos",
    "horticulture": "Sodininkystės paslaugos",
    "other": "Kitos paslaugos"
  },
  "admin": "Pagrindinis administratorius",
  "adminFirst": "Vardas",
  "adminLast": "Pavardė",
  "adminEmail": "Darbo el. paštas",
  "adminPhone": "Telefonas",
  "adminPw": "Slaptažodis",
  "adminPwHint": "Bent 10 simbolių ir bent vienas skaičius.",
  "adminPwShow": "Rodyti slaptažodį",
  "adminPwHide": "Slėpti slaptažodį",
  "terms": {
    "pre": "Sutinku su",
    "t": "Paslaugų teikimo sąlygomis",
    "and": "ir",
    "p": "Privatumo politika"
  },
  "cta": "Sukurti paskyrą ir tęsti",
  "errors": {
    "required": "Privalomas",
    "tooShort": "Per trumpa",
    "invalidEmail": "Įveskite teisingą el. paštą",
    "invalidVat": "Įveskite teisingą PVM kodą",
    "invalidBelgianVat": "Įveskite teisingą Belgijos PVM kodą (pvz., BE0123456789).",
    "invalidPhone": "Įveskite teisingą telefono numerį",
    "passwordWeak": "Bent 12 simbolių su vienu skaičiumi",
    "termsRequired": "Turite sutikti su sąlygomis",
    "emailExists": "Šis el. paštas jau naudojamas",
    "vatRequiredForBss": "PVM kodas reikalingas Belgijos socialiniam draudimui",
    "network": "Tinklo ar serverio klaida. Bandykite dar kartą.",
    "throttled": "Per daug bandymų. Bandykite dar kartą po {{minutes}} min."
  },
  "verify": {
    "awaitingTitle": "Patikrinkite savo el. paštą",
    "awaitingSub": "Išsiuntėme patvirtinimo nuorodą adresu {{email}}. Spustelėkite ją, kad aktyvuotumėte paskyrą ir pradėtumėte nemokamą bandomąjį laikotarpį.",
    "awaitingSubNoEmail": "Išsiuntėme jums patvirtinimo nuorodą. Spustelėkite ją, kad aktyvuotumėte paskyrą ir pradėtumėte nemokamą bandomąjį laikotarpį.",
    "resend": "Siųsti dar kartą",
    "resendCooldown": "Siųsti dar kartą po {{seconds}}s",
    "verifyingTitle": "Tikrinama…",
    "successTitle": "Jūsų nemokamas 30 dienų bandomasis laikotarpis prasidėjo!",
    "successSub": "Kredito kortelės nereikia. Prisijunkite prie savo skydelio ir pradėkite naudotis „Done-it“.",
    "errorTitle": "Nepavyko patvirtinti nuorodos",
    "errorSub": "Nuoroda galėjo nustoti galioti. Pradėkite iš naujo nuo paskyros duomenų.",
    "errorCta": "Atgal į paskyrą",
    "interstitial": "El. pašto patvirtinimas",
    "subscribedTitle": "Jūsų paskyra paruošta",
    "subscribedSub": "Mokėjimas jau atliktas. Prisijunkite prie skydelio, kad pradėtumėte naudoti „Done-it“.",
    "subscribedCta": "Prisijungti prie skydelio",
    "successCta": "Atidaryti skydelį",
    "successNote": "Bandomuoju laikotarpiu gausite keletą naudingų el. laiškų, o jam baigiantis – nuorodą prenumeruoti.",
    "awaitingSubFree": "Išsiuntėme patvirtinimo nuorodą adresu {{email}}. Spustelėkite ją, kad aktyvuotumėte nemokamą paskyrą — „Time Zero“ yra nemokama visam laikui, be kredito kortelės.",
    "awaitingSubFreeNoEmail": "Išsiuntėme jums patvirtinimo nuorodą. Spustelėkite ją, kad aktyvuotumėte nemokamą paskyrą — „Time Zero“ yra nemokama visam laikui, be kredito kortelės.",
    "successTitleFree": "Jūsų nemokama paskyra paruošta!",
    "successNoteFree": "„Time Zero“ yra nemokama visam laikui neviršijant jos ribų. Bet kada atnaujinkite planą neribotam naudojimui."
  }
}
